"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FILE_TYPES = void 0;
exports.default = DropZone;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@mui/styles");
var _CloudUploadRounded = _interopRequireDefault(require("@mui/icons-material/esm/CloudUploadRounded.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _Box = _interopRequireDefault(require("@mui/material/Box/Box.js"));
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FILE_TYPES = exports.FILE_TYPES = {
  EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
  JPG: 'image/jpeg',
  JPEG: 'image/jpeg',
  PDF: 'application/pdf',
  PNG: 'image/png',
  WORD: 'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  POWERPOINT: 'application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation',
  SVG: 'image/svg+xml',
  TEXT: 'text/plain',
  MP4: 'video/mp4',
  WEBM: 'video/webm',
  CSV: 'text/csv'
};
const useStyles = (0, _styles.makeStyles)(({
  spacing
}) => ({
  dropZone: {
    border: '2px dashed rgb(211, 211, 211)',
    color: 'rgb(180, 180, 180)'
  },
  dragAccept: {
    color: '#000',
    border: `2px dashed rgb(0, 150, 0)`,
    backgroundColor: `rgba(0, 150, 0, 0.5)`,
    '& svg': {
      opacity: 0.5
    }
  },
  dragReject: {
    color: '#000',
    border: `2px dashed rgb(240, 0, 0)`,
    backgroundColor: `rgba(240, 0, 0, 0.5)`,
    '& svg': {
      opacity: 0.5
    }
  },
  uploadIcon: {
    margin: spacing(1, 'auto')
  }
}));
function DropZone({
  children,
  className,
  height = 150,
  iconColor = 'inherit',
  message = 'Drop files here or click to open file explorer',
  onDrop,
  style,
  ...rest
}) {
  const classes = useStyles();
  function handleUpload(accepted, rejected, e) {
    if (accepted && accepted.length > 0 && onDrop) onDrop(accepted, rejected, e);
  }
  function makeClassName(isDragAccept, isDragReject) {
    return (0, _classnames.default)(className, {
      [classes.dropZone]: !children,
      [classes.dragAccept]: isDragAccept,
      [classes.dragReject]: isDragReject
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactDropzone.default, {
    onDrop: handleUpload,
    ...rest,
    children: ({
      getRootProps,
      getInputProps,
      open,
      isDragAccept,
      isDragReject
    }) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      ...getRootProps({
        className: makeClassName(isDragAccept, isDragReject)
      }),
      style: style,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        ...getInputProps()
      }), children?.(open) || /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
        display: "flex",
        flexDirection: "column",
        height: height,
        justifyContent: "center",
        textAlign: "center",
        width: "100%",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CloudUploadRounded.default, {
          className: classes.uploadIcon,
          color: iconColor,
          fontSize: "large"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          children: message
        })]
      })]
    })
  });
}